<div class="{{theme}}-theme">
    <div class="position-relative border-bottom" *ngIf="topic">

        <div class="topic-wrapper">
            <img src="{{topic.featureImageUrl}}" class="topic-featured-img" />


            <div class="df-topic">
                <div class="border-bottom">
                    <div class="container-fluid">
                        <div class="row py-4">
                            <div class="col-12 subtitle">{{topic.subtitle}}</div>
                            <div class="col-12 pt-3">
                                <h2>{{topic.title}}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid py-4">
                    <audio-transcript [source]="topic.audioUrl" [transcript]="topic.transcript"></audio-transcript>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="reflection-journal-theme border-bottom">
    <div class="container-fluid">
        <div class="row py-4">
            <div class="col-12">
                <h3 class="font-italic reflection-journal">Reflection Journal</h3>
            </div>
        </div>
    </div>
    <div *ngIf="topicAnswers">
        <div class="border-top" *ngFor="let question of topicAnswers.answers; let i=index">
            <div class="container-fluid py-4">
                <div class="row">
                    <div class="col-12 col-lg-10 subtitle">{{question.questionText}}</div>
                </div>
                <div class="row pt-2">
                    <div class="col-12 col-lg-9">
                        <elemental-input [question]="question" (answerChanged)="answerChanged($event, question.answerId, i)"></elemental-input>
                        <!-- <input type="text" class="form-control text-xlarge" ng-model="question.answer" [placeholder]="question.placeholder"
                            (change)="answerChanged($event, question.answerId, i)" value="{{question.answer}}"/> -->
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>